import { useTranslation } from 'react-i18next';

function StatusBadge({ status }) {
  const { t } = useTranslation();

  const statusConfig = {
    awaiting: { bg: '#fef3c7', color: '#92400e' },
    'picked up': { bg: '#dbeafe', color: '#1e40af' },
    delivered: { bg: '#d1fae5', color: '#065f46' },
    canceled: { bg: '#fee2e2', color: '#991b1b' },
  };

  const config = statusConfig[status] || statusConfig['awaiting'];
  const key = status.replace(' ', '_'); // "picked up" -> "picked_up" to match our JSON key format

  return (
    <span style={{
      backgroundColor: config.bg,
      color: config.color,
      fontSize: 11,
      fontWeight: 700,
      padding: '3px 10px',
      borderRadius: 999,
      whiteSpace: 'nowrap',
    }}>
      {t(`status.${key}`)}
    </span>
  );
}

export default StatusBadge;